import { useNavigate, useLocation, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PatientIcon from "../assets/icon/PatientIcon";
import AppointmentIcon from "../assets/icon/AppointmentIcon";
import ReferIcon from "../assets/icon/ReferIcon";
import NoshowIcon from "../assets/icon/NoshowIcon";
import DashboardIcon from "../assets/icon/DashboardIcon";
import DevicesIcon from "../assets/icon/DevicesIcon";
import AlertsIcon from "../assets/icon/AlertsIcon";
import ProvidersIcon from "../assets/icon/ProvidersIcon";
import CommunicationIcon from "../assets/icon/CommunicationIcon";
import PostDischargeIcon from "../assets/icon/PostDischargeIcon";
import ProcedureUpliftIcon from "../assets/icon/ProcedureUpliftIcon";
import EmergencyVisitIcon from "../assets/icon/EmergencyVisitIcon";

export const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useAuth();

  // Don't redirect while loading initial auth state
  if (isLoading) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!user || user.role !== "PROVIDER") {
    return <Navigate to="/provider-login" replace />;
  }

  // Get the current "section" from URL, e.g., 'appointment', 'patient', 'referral', 'noshow'
  // Assumes URL like /layout/appointment or /layout/noshow/123 etc.
  const currentPath = location.pathname.split("/")[2] || "dashboard";

  return (
    <div className="mainWrapper">
      <div className="navpanel">
        <div
          className={`navlink-tab ${currentPath === "dashboard" ? "selected" : ""}`}
          onClick={() => navigate("/layout/dashboard")}
        >
          <div className={`icon ${currentPath === "dashboard" ? "selected" : ""}`}>
            <DashboardIcon
              width={15}
              height={15}
              color={currentPath === "dashboard" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Dashboard</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "appointment" ? "selected" : ""}`}
          onClick={() => navigate("/layout/appointment")}
        >
          <div className={`icon ${currentPath === "appointment" ? "selected" : ""}`}>
            <AppointmentIcon
              width={15}
              height={15}
              color={currentPath === "appointment" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Appointments</div>
        </div>

        <div
          className={`navlink-tab ${currentPath === "patient" ? "selected" : ""}`}
          onClick={() => navigate("/layout/patient")}
        >
          <div className={`icon ${currentPath === "patient" ? "selected" : ""}`}>
            <PatientIcon
              width={15}
              height={15}
              color={currentPath === "patient" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Patients</div>
        </div>

        <div
          className={`navlink-tab ${currentPath === "referral" ? "selected" : ""}`}
          onClick={() => navigate("/layout/referral")}
        >
          <div className={`icon ${currentPath === "referral" ? "selected" : ""}`}>
            <ReferIcon
              width={15}
              height={15}
              color={currentPath === "referral" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Referrals</div>
        </div>

        <div
          className={`navlink-tab ${currentPath === "noshow" ? "selected" : ""}`}
          onClick={() => navigate("/layout/noshow")}
        >
          <div className={`icon ${currentPath === "noshow" ? "selected" : ""}`}>
            <NoshowIcon
              width={15}
              height={15}
              color={currentPath === "noshow" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">No Show</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "providers" ? "selected" : ""}`}
          onClick={() => navigate("/layout/providers")}
        >
          <div className={`icon ${currentPath === "providers" ? "selected" : ""}`}>
            <ProvidersIcon
              width={15}
              height={15}
              color={currentPath === "providers" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Providers</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "my-devices" ? "selected" : ""}`}
          onClick={() => navigate("/layout/my-devices")}
        >
          <div className={`icon ${currentPath === "my-devices" ? "selected" : ""}`}>
            <DevicesIcon
              width={15}
              height={15}
              color={currentPath === "my-devices" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Devices</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "alerts" ? "selected" : ""}`}
          onClick={() => navigate("/layout/alerts")}
        >
          <div className={`icon ${currentPath === "alerts" ? "selected" : ""}`}>
            <AlertsIcon
              width={15}
              height={15}
              color={currentPath === "alerts" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Alerts</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "communication" ? "selected" : ""}`}
          onClick={() => navigate("/layout/my-communication")}
        >
          <div className={`icon ${currentPath === "communication" ? "selected" : ""}`}>
            <CommunicationIcon
              width={15}
              height={15}
              color={currentPath === "communication" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Communication</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "post-discharge" ? "selected" : ""}`}
          onClick={() => navigate("/layout/post-discharge")}
        >
          <div className={`icon ${currentPath === "post-discharge" ? "selected" : ""}`}>
            <PostDischargeIcon
              width={15}
              height={15}
              color={currentPath === "post-discharge" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Post-Discharge</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "procedure-uplift" ? "selected" : ""}`}
          onClick={() => navigate("/layout/procedure-uplift")}
        >
          <div className={`icon ${currentPath === "procedure-uplift" ? "selected" : ""}`}>
            <ProcedureUpliftIcon
              width={15}
              height={15}
              color={currentPath === "procedure-uplift" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Procedure Uplift</div>
        </div>
        <div
          className={`navlink-tab ${currentPath === "emergency-visit" ? "selected" : ""}`}
          onClick={() => navigate("/layout/emergency-visit")}
        >
          <div className={`icon ${currentPath === "emergency-visit" ? "selected" : ""}`}>
            <EmergencyVisitIcon
              width={15}
              height={15}
              color={currentPath === "emergency-visit" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Emergency Visit</div>
        </div>
      </div>

      <div className="mainContainer">
        {/* Outlet will render nested routes like /layout/noshow, /layout/patient etc */}
        <Outlet />
      </div>
    </div>
  );
};
